import { compose } from 'redux';
import { Field, Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';
import * as validators from '../../util/validators';

import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from '../../util/reactIntl'
import { Form, FieldTextInput, Button, Modal } from '../../components';

import css from './AdminBlogPostForm.module.css';
import TinyMceEditor from '../../components/TinyMce/TinyMce';


const AdminBlogPostFormComponent = props => {
  const { initialValues, isEditMode, isLoading, onManageDisableScrolling } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <FinalForm
      {...props}
      initialValues={initialValues}
      mutators={{ ...arrayMutators }}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          formId,
          handleSubmit,
          intl,
          values,
          roleType,
          setFile,
          file,
          setSubmitType,
          submitType
        } = fieldRenderProps;
        const classes = classNames(rootClassName || css.root, className);

        const { title, description, content } = values
        const submitDisabled = !title || !description || !content || isLoading;

        return (
          <Form className={css.root} onSubmit={handleSubmit}>
            <div className={css.form}>

              <FieldTextInput
                className={css.inputField}
                id={formId ? `${formId}.title` : 'title'}
                name="title"
                label={intl.formatMessage({ id: 'AdminBlogPostForm.titleLabel' })}
                placeholder={intl.formatMessage({ id: 'AdminBlogPostForm.titlePlaceholder' })}
                validate={validators.required(intl.formatMessage({ id: 'AdminBlogPostForm.titleRequired' }))}
              />

              <FieldTextInput
                type="textarea"
                className={css.inputTextarea}
                id={formId ? `${formId}.description` : 'description'}
                name="description"
                label={intl.formatMessage({ id: 'AdminBlogPostForm.descriptionLabel' })}
                placeholder={intl.formatMessage({ id: 'AdminBlogPostForm.descriptionPlaceholder' })}
                validate={validators.required(intl.formatMessage({ id: 'AdminBlogPostForm.descriptionRequired' }))}
              />


              <FieldTextInput
                type="text"
                className={css.inputTextarea}
                id={formId ? `${formId}.readTime` : 'readTime'}
                name="readTime"
                label={intl.formatMessage({ id: 'AdminBlogPostForm.readTimeLabel' })}
                placeholder={intl.formatMessage({ id: 'AdminBlogPostForm.readTimePlaceholder' })}
                validate={validators.required(intl.formatMessage({ id: 'AdminBlogPostForm.readTimeRequired' }))}
              />


              <div className={css.fileInputWrapper}>
                <label className={css.uploadBox}>
                  <div className={css.uploadContent}>
                    <span className={css.uploadIcon}>📷</span>

                    <span className={css.uploadText}>
                      <FormattedMessage
                        id="AdminBlogPostForm.chooseFile"
                        defaultMessage="Click to upload image"
                      />
                    </span>

                    <span className={css.uploadSubText}>
                      JPG, PNG, WEBP (Max 10MB)
                    </span>
                  </div>

                  <input
                    type="file"
                    onChange={e => {
                      const selectedFile = e.target.files[0];
                      if (selectedFile) {
                        if (selectedFile.size > 10 * 1024 * 1024) {
                          setIsModalOpen(true);
                          e.target.value = null;
                        } else {
                          setFile(selectedFile);
                        }
                      }
                    }}
                    className={css.fileInput}
                    accept="image/*"
                  />
                </label>

                {file && (
                  <img
                    src={URL.createObjectURL(file)}
                    alt="Preview"
                    className={css.imagePreview}
                  />
                )}

                {isEditMode && !file && initialValues?.image && (
                  <img
                    src={initialValues.image}
                    alt="Current"
                    className={css.imagePreview}
                  />
                )}
              </div>


              <Field
                name="content"
                validate={validators.required(
                  intl.formatMessage({ id: 'AdminBlogPostForm.contentRequired' })
                )}
              >
                {({ input, meta }) => <>

                  <TinyMceEditor input={input} />
                  {meta.touched && meta.error && (
                    <span className={css.error}>{meta.error}</span>
                  )}

                </>}
              </Field>


            </div>
            <div className={css.bottomWrapper}>
              <Button
                type="submit"
                inProgress={isLoading && submitType == "draft"}
                disabled={isLoading}
                onClick={() => setSubmitType("draft")}
              >
                Save Draft
              </Button>

              <Button
                type="submit"
                inProgress={isLoading && submitType == "published"}
                disabled={submitDisabled}
                onClick={() => setSubmitType("published")}
              >
                {isEditMode ? "Update & Publish" : "Publish"}
              </Button>
            </div>
            <Modal
              id="image-size-error-modal"
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onManageDisableScrolling={onManageDisableScrolling || (() => { })}
              usePortal
            >
              <div style={{ padding: '24px', textAlign: 'center' }}>
                <h3 style={{ marginTop: 0 }}>Image too large</h3>
                <p>The image size exceeds the 10MB limit. Please select a smaller file.</p>
                <Button type="button" onClick={() => setIsModalOpen(false)}>Select a different file</Button>
              </div>
            </Modal>
          </Form>
        );
      }}
    />
  );
};


const AdminBlogPostForm = compose(injectIntl)(AdminBlogPostFormComponent);
AdminBlogPostForm.displayName = 'AdminBlogPostForm';

export default AdminBlogPostForm;
